// @flow
import _ from 'lodash';
import { SET_LOCATION_URL } from '../connection/actionTypes';
import { participantUpdated } from '../participants/actions';
import { getLocalParticipant } from '../participants/functions';
import MiddlewareRegistry from '../redux/MiddlewareRegistry';
import { parseURLParams } from '../util/parseURLParams';
import { SETTINGS_UPDATED } from './actionTypes';
import { updateSettings } from './actions';
/**
 * The middleware of the feature base/settings. Distributes changes to the state
 * of base/settings to the states of other features computed from the state of
 * base/settings.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case SETTINGS_UPDATED:
            _updateLocalParticipant(store, action);
            break;
        case SET_LOCATION_URL:
            _updateLocalParticipantFromUrl(store);
            break;
    }
    return result;
});
/**
 * Maps the settings field names to participant names where they don't match.
 * Currently there is only one such field, but may be extended in the future.
 *
 * @private
 * @param {string} settingsField - The name of the settings field to map.
 * @returns {string}
 */
function _mapSettingsFieldToParticipant(settingsField) {
    switch (settingsField) {
        case 'displayName':
            return 'name';
    }
    return settingsField;
}
/**
 * Updates the local participant according to settings changes.
 *
 * @param {Store} store - The redux store.
 * @param {Object} action - The dispatched action.
 * @private
 * @returns {void}
 */
function _updateLocalParticipant({ dispatch, getState }, action) {
    var _a;
    const { settings } = action;
    const localParticipant = getLocalParticipant(getState());
    const newLocalParticipant = Object.assign({}, localParticipant);
    for (const key in settings) {
        if (settings.hasOwnProperty(key)) {
            newLocalParticipant[_mapSettingsFieldToParticipant(key)]
                = settings[key];
        }
    }
    dispatch(participantUpdated(Object.assign(Object.assign({}, newLocalParticipant), { id: (_a = newLocalParticipant.id) !== null && _a !== void 0 ? _a : '' })));
}
/**
 * Returns the userInfo set in the URL.
 *
 * @param {Store} store - The redux store.
 * @private
 * @returns {void}
 */
export function _updateLocalParticipantFromUrl({ dispatch, getState }) {
    var _a;
    const urlParams = parseURLParams((_a = getState()['features/base/connection'].locationURL) !== null && _a !== void 0 ? _a : '');
    const urlEmail = urlParams['userInfo.email'];
    const urlDisplayName = urlParams['userInfo.displayName'];
    if (!urlEmail && !urlDisplayName) {
        return;
    }
    const localParticipant = getLocalParticipant(getState());
    if (localParticipant) {
        const displayName = _.escape(urlDisplayName);
        const email = _.escape(urlEmail);
        dispatch(participantUpdated(Object.assign(Object.assign({}, localParticipant), { email, name: displayName })));
        dispatch(updateSettings({
            displayName,
            email
        }));
    }
}
